import React, { FC, useState, useEffect, Dispatch, SetStateAction } from 'react';
import { Box, Typography } from '@mui/material';

import EditorToggle from '../../../sharedModules/form/components/EditorToggle';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import DeleteConfirmationModal from '../../../sharedModules/layout/DeleteConfirmationModal';

import { minimumLoading } from '../../../utils/minimumLoading';

import { WaterAuthority } from '../../model';
import CreatorToggle from '../../../sharedModules/form/components/CreatorToggle';

import axios from '../../../sharedModules/utils/axios.utils';

interface AuthorityProvidedFieldConfigProps {
  waterAuthority: WaterAuthority;
}

const AuthorityProvidedFieldConfig: FC<AuthorityProvidedFieldConfigProps> = (props) => {
  const { waterAuthority } = props;

  const [authorityProvidedFields, setAuthorityProvidedFields] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const fetchAuthorityProvidedFields = async () => {
    try {
      const response: any = await axios.get(`/backflows/authority_provided_fields`, {
        params: {
          water_authority_id: waterAuthority.id,
        },
      });
      setAuthorityProvidedFields(response.data.result);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong fetching the Authority Provided Fields');
    }
  };

  useEffect(() => {
    if (waterAuthority?.id) {
      minimumLoading(fetchAuthorityProvidedFields, setLoading);
    }
  }, [waterAuthority]);

  return (
    <LoadingWrapper isLoading={loading} message="Loading">
      <DeleteConfirmationModal refetchParentRecord={fetchAuthorityProvidedFields} />
      <Box>
        <ErrorMessage message={errorMessage} />
        <Typography variant="h6" fontWeight="600">
          Authority Provided Field Config
        </Typography>
        {authorityProvidedFields.map((field) => (
          <EditorToggle
            afterUpdate={fetchAuthorityProvidedFields}
            allowDelete
            key={field.id}
            record={field}
            controller="backflows/authority_provided_fields"
            field="field_label"
          />
        ))}
        <CreatorToggle
          label="Field"
          controller="backflows/authority_provided_fields"
          field="field_label"
          otherParams={{ water_authority_id: waterAuthority.id }}
          afterCreate={fetchAuthorityProvidedFields}
        />
      </Box>
    </LoadingWrapper>
  );
};

export default AuthorityProvidedFieldConfig;
